import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
const init = {
  brands: [],
  brand: [],
}

const initFilterCounts = {
  'example': {
    'example2': 1
  }
}

// (
//   {
//     exampleFilterName: {
//       exampleFilterDescription: false
//     },
//     brands: {
//       exampleBrandName: false
//     }
//   }
// )

// use FILTER_BRANDS and FILTER_OPTIONS to generate a json of filters 
const useFilter = () => {

  const [filters, setFilters] = useState({});
  const [filterCounts, setFilterCounts] = useState(initFilterCounts);
  const [selectedFilters, setSelectedFilters] = useState({});

  const [searchParams, setSearchParams] = useSearchParams();

  const fetchFiltersAPI = async () => {

  }

  const parseRawOptions = (filterOptions = (JSON.parse(FILTER_OPTIONS) || []), brands = (FILTER_BRANDS || [])) => {

    const options = filterOptions?.reduce((acc, each) => {
      if (!acc[each.name])
        acc[each.name] = [each.description];
      else {
        acc[each.name] = acc[each.name].concat(each.description);
      }
      return acc || {};
    }, {});

    setFilters({
      brand: brands,
      ...options
    })
  }

  const resetSelectedFilters = () => {
    setSelectedFilters({})
  }

  const addRemoveSelectedFilter = (filter = {}, action = 'add') => {
    switch (action) {
      case 'add':
        setSelectedFilters(prev => {
          if (prev[filter.name] && prev[filter.name][filter.description]) return prev;
          return {
            ...prev,
            [filter.name]: {
              ...(prev[filter.name] || {}),
              [filter.description]: true
            }
          };
        })
        break;
      case 'remove':
        setSelectedFilters(prev => {
          delete prev[filter.name][filter.description];
          if (!Object.values(prev[filter.name])?.length) {
            delete prev[filter.name];
            return {
              ...prev
            };
          } 
          return {
            ...prev,
            [filter.name]: {
              ...(prev[filter.name] || {}),
              // [filter.description]: false
            }
          }
        })
        break;
      default:
        return;
    }
  }

  const parseFilterCounts = (arr = (FILTER_COUNTS || [])) => {
    const json = arr?.reduce((acc, each) => {
      if (!acc[each.name])
        acc[each.name] = {}
      acc[each.name][each.description] = each.count
      return acc;

    }, {})

    setFilterCounts(json);
  }

  const initSelectedFilter = () => {

    const str = searchParams.get('filter');
    if(!str)
     return;
    const [name, description] = str?.split(':');
    setSelectedFilters({
      [name]: {
        [description]: true
      }
    })
  }

  useEffect(() => {
    parseRawOptions();
    parseFilterCounts();
    initSelectedFilter();
  }, [])


  return {
    filters,
    selectedFilters,
    filterCounts,
    addRemoveSelectedFilter,
    resetSelectedFilters

  }
}
export default useFilter;